module.exports = __webpack_public_path__ + "static/wristbands-322733800abb6a769b8213b11f29955c.svg";